import { call, put, takeLatest, takeEvery } from "redux-saga/effects";

import {
  GOT_INVOICE,
  GET_INVOICE,
  GET_POS_SETTINGS,
  GOT_POS_SETTINGS,
  CREATE_INVOICE,
  CREATED_INVOICE,
  UPDATE_INVOICE,
  UPDATED_INVOICE,
  UPDATE_BOOKING_TO_INVOICE,
  UPDATED_BOOKING_TO_INVOICE,
  GET_BOOKING_PAYMENTS,
  GOT_BOOKING_PAYMENTS,
  REFUND_INVOICE_PAYMENT,
  REFUNDED_INVOICE_PAYMENT,
  CHARGE_EXISTING_CARD,
  CHARGED_EXISTING_CARD,
  SEND_SHARE_INVOICE,
  SENT_SHARE_INVOICE,
  GET_INVOICE_PDF,
  GOT_INVOICE_PDF,
  FIND_GIFT_CERTIFICATE,
  FOUND_GIFT_CERTIFICATE,
  REDEEM_GIFT_CERTIFICATE,
  REDEEMED_GIFT_CERTIFICATE,
  CREATE_GIFT_CERTIFICATE,
  CREATED_GIFT_CERTIFICATE,
  GET_GIFTCERT_SETTING,
  GOT_GIFTCERT_SETTING,
  GET_GIFT_CERTIFICATE,
  GOT_GIFT_CERTIFICATE,
  GET_PAYMENT_SETTING,
  PAYMENT_SETTING_SUCCESS,
} from "../checkoutAppointmentStep";
import { getLocalStorageItem, getSpId, getOrgId } from "../../utils/helpers";
import { handleApiErrors, IsvalidId } from "./helpers";
import { UPDATED_GLOBAL_SUCCESS_MESSAGE } from "../globalSuccess";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../globalError";

/***** SAGA START ******/
export let getPosSettingsApi = () => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${window.APP.apiPath}api/serviceprovider/${getSpId()}/possettings`,
      {
        headers: {
          Authorization: getLocalStorageItem("token_authorization"),
        },
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadPosSettings() {
  try {
    const data = yield call(getPosSettingsApi);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_POS_SETTINGS, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let getGiftCertSettingApi = () => {
  return fetch(
    `${window.APP.apiPath}api/serviceprovider/${getSpId()}/settings/giftcerts`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
      },
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadGiftCertSetting() {
  try {
    const data = yield call(getGiftCertSettingApi);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_GIFTCERT_SETTING, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let getInvoiceApi = ({ invoiceKey }) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/invoices/${invoiceKey}`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") },
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadExistingInvoice(invoiceKey) {
  try {
    const data = yield call(getInvoiceApi, invoiceKey);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_INVOICE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let createInvoiceApi = ({ payload }, cb) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${window.APP.apiPath}api/serviceprovider/${getSpId()}/invoices`,
      {
        headers: {
          Authorization: getLocalStorageItem("token_authorization"),
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            if (cb) {
              cb();
            }
            return result;
          }
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadCreatedInvoice(invoiceToCreate) {
  try {
    const data = yield call(
      createInvoiceApi,
      invoiceToCreate,
      invoiceToCreate.cb
    );
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: CREATED_INVOICE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let updateInvoiceApi = ({ invoiceKey, payload }, cb) => {
  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/invoices/${invoiceKey}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (cb) {
          cb();
        }
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadUpdatedInvoice(updatedInvoice) {
  try {
    const data = yield call(
      updateInvoiceApi,
      updatedInvoice,
      updatedInvoice.cb
    );
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: UPDATED_INVOICE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let updateBookingToInvoiceApi = ({ bookingId, payload, cb }) => {
  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/bookings/${bookingId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/vnd.manager-v2+json",
        Accept: "application/vnd.manager-v2+json",
      },
      method: "PUT",
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (cb) {
            cb();
          }
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadUpdatedBookingToInvoice(payloadObject) {
  try {
    const data = yield call(updateBookingToInvoiceApi, payloadObject);
    if (!data || data.error) {
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: "",
        },
      });
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: UPDATED_BOOKING_TO_INVOICE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
export let loadBookingPaymentsApi = ({ bookingId, cb }) => {
  return fetch(`${window.APP.apiPath}api/bookings/${bookingId}/payments`, {
    headers: {
      Authorization: getLocalStorageItem("token_authorization"),
      Accept: "application/vnd.manager-v2+json",
    },
    method: "GET",
  })
    .then((response) => {
      return response.json().then((result) => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (cb) {
            cb();
          }
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadBookingPayments(payloadObject) {
  try {
    const data = yield call(loadBookingPaymentsApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_BOOKING_PAYMENTS, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let loadRefundInvoicePaymentApi = ({ bookingId, paymentId }) => {
  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/bookings/${bookingId}/payments/${paymentId}/refund`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/vnd.manager-v2+json",
        Accept: "application/vnd.manager-v2+json",
      },
      method: "POST",
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadRefundInvoicePayment(payloadObject) {
  try {
    const data = yield call(loadRefundInvoicePaymentApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: REFUNDED_INVOICE_PAYMENT, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let loadChargeExistingCardApi = ({ bookingId, payload, cb }) => {
  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/bookings/${bookingId}/chargecard`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/vnd.manager-v2+json",
        Accept: "application/vnd.manager-v2+json",
      },
      method: "POST",
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (cb) {
            cb();
          }
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadChargeExistingCard(payloadObject) {
  try {
    const data = yield call(loadChargeExistingCardApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: CHARGED_EXISTING_CARD, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let loadSendShareInvoiceApi = ({ invoiceKey, payload }) => {
  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/invoices/${invoiceKey}/email`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "POST",
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* loadSendShareInvoice(payloadObject) {
  try {
    const data = yield call(loadSendShareInvoiceApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SENT_SHARE_INVOICE, data }); // Yields effect to the reducer specifying the action type and user details
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message:
            window.APP.LANGUAGE.Success.SharedInvoice +
            " " +
            payloadObject.payload.emailaddress,
          icon: "sent_icon",
        },
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let loadInvoicePdfApi = ({ invoiceKey }) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/invoices/${invoiceKey}/pdf`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") },
        method: "GET",
      }
    )
      .then((response) => {
        return response.blob();
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadInvoicePdf(payloadObject) {
  try {
    const data = yield call(loadInvoicePdfApi, payloadObject);
    yield put({ type: GOT_INVOICE_PDF, data }); // Yields effect to the reducer specifying the action type and user details
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let searchGiftCertificateApi = ({ payload }) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${window.APP.apiPath}api/serviceprovider/${getSpId()}/giftcerts/search`,
      {
        headers: {
          Authorization: getLocalStorageItem("token_authorization"),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          return result;
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* searchGiftCertificate(payloadObject) {
  try {
    const data = yield call(searchGiftCertificateApi, payloadObject);
    let giftCertCode = payloadObject.payload.query.toLocaleUpperCase();
    let giftCertData = data.find(
      (giftCert) => giftCert.code.toLocaleUpperCase() == giftCertCode
    );
    if (giftCertData) {
      if (giftCertData.balance > 0) {
        yield put({ type: FOUND_GIFT_CERTIFICATE, data: giftCertData }); // Yields effect to the reducer specifying the action type and user details
      } else {
        yield put({
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: {
            message: window.APP.LANGUAGE.Errors.GiftCertNoBalance,
            icon: "info",
          },
        }); // Yields effect to the reducer specifying the action type and user details
      }
    } else {
      yield put({
        type: UPDATED_GLOBAL_ERROR_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Errors.GiftCertNotFound,
          icon: "info",
        },
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let redeemGiftCertificateApi = ({ giftCertKey, payload }) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/giftcerts/${giftCertKey}/redeem`,
      {
        headers: {
          Authorization: getLocalStorageItem("token_authorization"),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "PUT",
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          return result;
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* redeemGiftCertificate(payloadObject) {
  try {
    const data = yield call(redeemGiftCertificateApi, payloadObject);
    yield put({ type: REDEEMED_GIFT_CERTIFICATE, data }); // Yields effect to the reducer specifying the action type and user details
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let createGiftCertificateApi = ({ payload, cb }) => {
  return fetch(
    `${window.APP.apiPath}api/serviceprovider/${getSpId()}/giftcerts`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "POST",
      body: JSON.stringify(payload),
    }
  )
    .then((response) => {
      return response.json().then((result) => {
        if (cb && result.key) {
          cb(result.key);
        }
        if (
          result.code &&
          result.code != 200 &&
          result.status &&
          result.status == "failed"
        ) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};

function* createGiftCertificate(payloadObject) {
  try {
    const data = yield call(createGiftCertificateApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: CREATED_GIFT_CERTIFICATE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let getGiftCertificateApi = ({ giftCertKey }) => {
  if (IsvalidId(getSpId())) {
    return fetch(
      `${
        window.APP.apiPath
      }api/serviceprovider/${getSpId()}/giftcerts/${giftCertKey}`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") },
        method: "GET",
      }
    )
      .then((response) => {
        return response.json().then((result) => {
          return result;
        });
      })
      .catch((error) => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* getGiftCertificate(payloadObject) {
  try {
    const data = yield call(getGiftCertificateApi, payloadObject);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_GIFT_CERTIFICATE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

// PAUYMENT DETIALS
function* getPaymentDetails() {
  try {
    const URL = `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/settings/payments`;
    const options = {
      headers: { Authorization: getLocalStorageItem("token_authorization") },
      method: "GET",
    };

    const response = yield call(fetch, URL, options);
    const data = yield call([response, "json"]);

    yield put({ type: PAYMENT_SETTING_SUCCESS, data });
  } catch (e) {
    return handleApiErrors({ generalError: true });
  }
}

function* watchRequests() {
  yield* [
    takeEvery(GET_INVOICE, loadExistingInvoice),
    takeLatest(GET_POS_SETTINGS, loadPosSettings),
    takeLatest(GET_GIFTCERT_SETTING, loadGiftCertSetting),
    takeEvery(CREATE_INVOICE, loadCreatedInvoice),
    takeLatest(UPDATE_INVOICE, loadUpdatedInvoice),
    takeLatest(UPDATE_BOOKING_TO_INVOICE, loadUpdatedBookingToInvoice),
    takeLatest(GET_BOOKING_PAYMENTS, loadBookingPayments),
    takeLatest(REFUND_INVOICE_PAYMENT, loadRefundInvoicePayment),
    takeLatest(CHARGE_EXISTING_CARD, loadChargeExistingCard),
    takeLatest(SEND_SHARE_INVOICE, loadSendShareInvoice),
    takeLatest(FIND_GIFT_CERTIFICATE, searchGiftCertificate),
    takeLatest(REDEEM_GIFT_CERTIFICATE, redeemGiftCertificate),
    takeLatest(CREATE_GIFT_CERTIFICATE, createGiftCertificate),
    takeEvery(GET_GIFT_CERTIFICATE, getGiftCertificate),
    takeLatest(GET_INVOICE_PDF, loadInvoicePdf),
    takeLatest(GET_PAYMENT_SETTING, getPaymentDetails),
  ];
}

export default [watchRequests];
